import {Injectable, ReflectiveInjector} from "@angular/core";
import {AuthErrorEventer} from '../../app.helpers';

@Injectable()
export class ModalWinNewLeadService {

    private static _instance:ModalWinNewLeadService;

    private constructor() {
        ModalWinNewLeadService._instance = this;
        AuthErrorEventer.getIt().event = () => {
            if (this._component)
                this._component.hide();
        };
    }

    public static getInstance():ModalWinNewLeadService {
        if (! ModalWinNewLeadService._instance)
            ModalWinNewLeadService._instance = new ModalWinNewLeadService()
        return ModalWinNewLeadService._instance;
    }

    private _component: any = false;

    setComponent(component: any) {
        this._component = component;
    }

    show() {
        if (! this._component) return;
        this._component.show(true);
    }
}


// WEBPACK FOOTER //
// ./src/app/views/modal-win-new-lead/win.service.ts